<template>
<div class="page-content-warehouse__body--filter">
	<div class="row">
		<div class="col col-12">
			<label for="" class="font-weight-bold">{{ $t('Set warehouse by') }}</label>
		</div>
		<div
			v-for="(item, i) in filterWarehouses"
			:key="i"
			class="col col-md-6"
		>
			<div
				class="form-group radio-box mb-2"
				:class="{ active: item.key === selectedWarehouse }">
				<label class="custom-control custom-radio">
					<input
						name="name"
						type="radio"
						:value="item.key"
						v-model="selectedWarehouse"
						class="custom-control-input"
						@input="onSelectedWarehouse(item)"
					/>
					<div v-if="$slots['default']">
						<slot name="default" />
					</div>
					<div v-else class="custom-control-label font-weight-bold">
						<span>{{ $t(item.title) }}</span>
						<i
							v-if="showInfo"
							class="material-icons info"
							v-tooltip="$t(item.desc)">
							info
						</i>
					</div>
					<small v-if="!showInfo">{{ $t(item.desc) }}</small>
				</label>
			</div>
		</div>
	</div>
</div>
</template>

<script>

const filterWarehouses = [
	{
		title: 'Nearest',
		desc: 'Buyers can choose a warehouse based on the closest distance',
		key: 'nearest',
	},
	{
		title: 'Cheapest',
		desc: 'Buyers can choose a warehouse based on the cheapest postage',
		key: 'shipping_cost',
	},
];
export default {
	name: 'SettingWarehouseSectionBodyFilter',
	props: {
		select: {
			type: String,
			default: () => 'nearest',
		},
		showInfo: {
			type: Boolean,
			default: () => false,
		},
	},
	data: () => ({
		selectedWarehouse: 'nearest',
		filterWarehouses,
	}),
	watch: {
		select(select) {
			if (select) {
				this.selectedWarehouse = select;
			}
		},
	},
	created() {
		if (this.select) {
			this.selectedWarehouse = this.select;
		}
	},
	methods: {
		onSelectedWarehouse(warehouse) {
			this.$emit('change', warehouse.key);
		},
	},
};
</script>

<style lang="scss" scoped>
.radio-box {
	border-radius: 6px;
	padding: 12px;
	flex-direction: row;
	display: flex;
	align-items: center;
	margin: 10px 0;
	border: 1px solid #ddd;

	&.active {
		border: 1px solid #0098da;
		background-color: aliceblue;
	}
}
</style>
